<template>
  <div id="dashboard" style="min-height: 650px;">
    <!-- Page Content -->
    <div class="content">
      <div class="block block-rounded block-bordered">
        <ul
          class="nav nav-tabs nav-tabs-block nav-main nav-main-horizontal nav-main-hover"
          data-toggle="tabs"
          role="tablist"
        >
          <li class="nav-item" v-for="(item,index) in bis" :key="index">
            <a
              class="nav-link"
              :class="item.BIS_TYPE == bisType ? 'active' + ' btabs-animated-fade-'+item.BIS_TYPE : 'btabs-animated-fade-'+item.BIS_TYPE "
              href="javascript:void(0)"
              @click="showTab('btabs-animated-fade-'+item.BIS_TYPE,item.BIS_TYPE)"
            >{{item.BIS_NAME}}</a>
          </li>

          <li class="ml-auto nav-main-item add"></li>
          <button
            type="button"
            class="btn-block-option"
            data-toggle="block-option"
            data-action="fullscreen_toggle"
            style="margin-right: 1.25rem"
          >
            <i class="si si-size-fullscreen"></i>
          </button>
        </ul>
        <div class="block-content tab-content overflow-hidden">
          <div class="tab-pane fade show active" id="btabs-animated-fade-1" role="tabpanel">
            <carportChargeUser ref="carportChargeUser"></carportChargeUser>
          </div>
          <div class="tab-pane fade" id="btabs-animated-fade-2" role="tabpanel">
            <carportWhite ref="carportWhite"></carportWhite>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Util from "../../../Util.js";
import carportChargeUser from "./carportChargeUser";
import carportWhite from "./whiteList";

export default {
  name: "whiteListUsers",
  components: {
    carportChargeUser,
    carportWhite
  },
  data() {
    return {
      bis: [
        {
          BIS_TYPE: "1",
          BIS_NAME: "白名单充电用户"
        },
        {
          BIS_TYPE: "2",
          BIS_NAME: "白名单车棚用户"
        }
      ],
      setToday: new Date(),
      starttime: "",
      endtime: "",
      page: 1,
      size: 10,
      total: 1,
      bisType: 1,
      pro: "",
      city: "",
      dis: "",
      edit: "",
      provinceList: [],
      cityList: [],
      districtList: [],
      cellList: [],
      carportList: [],
      carTypeList: [],
      created: true,
      form: {
        carportId: "",
        modelType: "",
        startTime: "",
        endTime: "",
        modelNo: "",
        remark: "",
        userId: ""
      },
      cardNo: "",
      phone: "",
      addTypeList: [
        {
          value: "3",
          label: "用户ID"
        },
        {
          value: "1",
          label: "手机号码"
        },
        {
          value: "2",
          label: "实体卡号"
        }
      ]
    };
  },
  computed: {
    duration() {
      return this.$store.state.duration;
    },
    roleName() {
      return this.$store.state.roleName;
    },
    params() {
      return this.$store.state.params;
    }
  },
  watch: {
    "$store.state.duration": {
      handler: function(val, oldVal) {
        if (typeof oldVal === "undefined") return;
        if (JSON.stringify(val) != JSON.stringify(oldVal)) {
          this.$refs.carportChargeUser.getList();
          this.$refs.carportWhite.getList();
        }
      },
      immediate: true,
      deep: true
    },
    "form.validTime"(val, oldVal) {
      this.form.validTime = Util.testNumberFn(val, "inputChangeNoDecimal");
    },
    "form.limit_duration"(val, oldVal) {
      this.form.limit_duration = Util.testNumberFn(val, "inputChangeNoDecimal");
    },
    "form.payMoney"(val, oldVal) {
      this.form.payMoney = Util.testNumberFn(val, "inputChangeTwoDecimal");
    },
    "form.sysDuration"(val, oldVal) {
      this.form.sysDuration = Util.testNumberFn(val, "inputChangeNoDecimal");
    },
    "form.valIdTime"(val, oldVal) {
      if (val) {
        if (val == "0") {
          this.form.packageName = "日租包";
        } else {
          this.form.packageName = val + "个月";
        }
      }
    },
    "form.duration"(val, oldVal) {
      if (this.edit == "system") {
        this.form.duration = Util.testNumberFn(val, "inputChangeNoDecimal");
      }
    }
  },
  mounted() {
    if (this.params.type && this.params.type == "carport") {
      this.showTab("btabs-animated-fade-2", 2);
    }
    this.getProvince();
    this.searchCarport();
    this.searchCarType();
  },
  methods: {
    changeValIdType() {
      if (this.form.packageType == 0) {
        this.form.duration = "";
      }
    },
    changeCarport() {
      this.form.sysDuration = "";
    },
    durationBlur() {
      if (this.form.duration) {
        this.form.customName = this.form.duration + "小时";
      }
    },
    chengType() {
      if (this.form.packageType == "2") {
        this.form.validTime = "";
      }
    },
    changeTwoDecimal(val) {
      return Util.changeTwoDecimal(val);
    },

    showTab(el, type) {
      $(`.${el}`).tab("show");
      for (let i of $(`.tab-pane`)) {
        i.className = "tab-pane fade";
      }
      $(`#${el}`).tab("show");
      this.bisType = type;
      if (type == 1) {
        this.$refs.carportChargeUser.getList();
      } else if (type == 2) {
        this.$refs.carportWhite.getList();
      }
    },
    searchCarType() {
      this.$http.get(`${Util.searchURL}/Carport/SearchByCarType?key=`).then(
        res => {
          if (res.data.code === 200) {
            this.carTypeList = res.data.data;
          }
        },
        err => {
          console.log(err);
        }
      );
    },
    searchCarport() {
      this.$http.get(`${Util.searchURL}/Carport/ListByAll?key=`).then(
        res => {
          if (res.data.code === 200) {
            this.carportList = res.data.data;
          }
        },
        err => {
          console.log(err);
        }
      );
    },
    getProvince() {
      this.$http.get(`${Util.searchURL}/Province/ListAll`).then(
        res => {
          if (res.data.code === 200) {
            this.provinceList = res.data.data;
          }
        },
        err => {
          console.log(err);
        }
      );
    },
    provinceSel() {
      let pid = $(`#cell-province-sel`).val();
      this.$http.get(`${Util.searchURL}/City/ListByProvince/${this.pro}`).then(
        res => {
          if (res.data.code === 200) {
            this.cityList = res.data.data;
            this.city = "";
            this.dis = "";
            this.form.cellId = "";
          }
        },
        err => {
          console.log(err);
        }
      );
    },
    citySel() {
      this.$http.get(`${Util.searchURL}/District/ListByCity/${this.city}`).then(
        res => {
          if (res.data.code === 200) {
            this.districtList = res.data.data;
            this.dis = "";
            this.form.cellId = "";
          }
        },
        err => {
          console.log(err);
        }
      );
    },
    disSel() {
      this.$http
        .get(`${Util.searchURL}/FlatComplex/ListByDistrict/${this.dis}`)
        .then(
          res => {
            if (res.data.code === 200) {
              this.cellList = res.data.data;
              this.form.cellId = "";
            }
          },
          err => {
            console.log(err);
          }
        );
    },
    searchPackge() {
      if (this.form.carportId == "") return;
      this.$http
        .get(
          `${Util.searchURL}/Carport/SearchByChargePackage/${this.form.carportId}?key=`
        )
        .then(
          res => {
            if (res.data.code === 200) {
              this.packageList = res.data.data;
            }
          },
          err => {
            console.log(err);
          }
        );
    }
  }
};
</script>
